import { ZOOM_MAX, ZOOM_MIN } from "@components/DocumentReviewModal/hooks/useZoomAndPan";

interface ZoomControlsProps {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({ scale, onZoomIn, onZoomOut }) => {
  return (
    <div className="absolute bottom-6 right-6 flex flex-col gap-2 z-10">
      <button
        type="button"
        onClick={onZoomIn}
        disabled={scale >= ZOOM_MAX}
        className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center text-xl text-text-primary hover:bg-limestone-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        title="Zoom in"
        aria-label="Zoom in"
      >
        +
      </button>
      <button
        type="button"
        onClick={onZoomOut}
        disabled={scale <= ZOOM_MIN}
        className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center text-xl text-text-primary hover:bg-limestone-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        title="Zoom out"
        aria-label="Zoom out"
      >
        −
      </button>
    </div>
  );
};
